import { routes } from '../config/api_routes'

export const orderService = {
    getOrders: (filters) => window.axios.post(routes.getOrdersApi, filters),
    getDriverOrders: (filters) => window.axios.post(routes.getDriverOrders,filters),
    getOrder: (id) => window.axios.post(routes.getOrderApi, {order_id: id}),
    getOrderAdmin: (id) => window.axios.post(routes.getOrderAdminApi, {order_id: id}),
    getDriverOrdersCount: (filters) => window.axios.post(routes.getDriverOrdersCountApi,filters),
    getOrdersCount: (filters) => window.axios.post(routes.getOrdersCountApi,filters),
    exportOrders: (filters) => window.axios.post(routes.exportOrdersApi, filters),
    getNewOrders: (filters) => window.axios.post(routes.getNewOrdersApi, filters),
    checkAvailableDrivers: (data)   =>   window.axios.get(routes.checkAvailableDriversApi, {params: data}),
    assignDriver: (data)   =>   window.axios.post(routes.assignDriverApi, data),
    reassignDriver: (data)   =>   window.axios.post(routes.reassignDriverApi, data),
    getOrderById: (data)   =>   window.axios.post(routes.getOrderByIdApi, data),
    getOrderDetailById: (data)   =>   window.axios.post(routes.getOrderDetailByIdApi, data),
    getOrderItem: (data)   =>   window.axios.post(routes.getOrderItemApi, data),
    updateOrder: (data)   =>   window.axios.post(routes.updateOrderApi, data),
    getCoupon: (data)   =>   window.axios.post(routes.getCouponApi, data),
    createInvoice: (data)   =>   window.axios.post(routes.createInvoiceApi, data),
    getOrderPaidUnpaidAmounts: (id) => window.axios.post(routes.getOrderPaidUnpaidAmounts,{id:id}),
    getCustomerByEmail: (formData) => window.axios.post(routes.getCustomerByEmailApi,formData),
    addOrderCustomer: (formData) => window.axios.post(routes.addOrderCustomerApi,formData),
    getVariantByProduct: (formData) => window.axios.post(routes.getVariantByProductApi,formData),
    getTimeSlotByDate: (formData) => window.axios.post(routes.getTimeSlotByDateApi,formData),
    getTimeSloApi: (formData) => window.axios.post(routes.getTimeSloApi,formData),
    getCharges: (formData) => window.axios.post(routes.getChargesApi,formData),
    getShippingAddress: (formData) => window.axios.post(routes.getShippingAddressApi,formData),
    checkQuantity: (formData) => window.axios.post(routes.checkQuantityApi,formData),
    getProductSearching: (formData) => window.axios.post(routes.getProductSearchingApi,formData),
    getCredit: (formData) => window.axios.post(routes.getCreditApi,formData),
    orderReadyToCollect: (data) => window.axios.post(routes.orderReadyToCollectApi, data),
    adminOrderCancel: (data) => window.axios.post(routes.adminOrderCancelApi, data),
    // app apis 
    // ADD APP API BELOW
    changeOrderStatus: (data) => window.axios.post(routes.changeOrderStatusApi, data),
    ownerOrderStatus: (data) => window.axios.post(routes.ownerOrderStatusApi, data),
    cancelOrder: (data) => window.axios.post(routes.cancelOrderApi, data),
    deliverOrder: (data) => window.axios.post(routes.deliverOrderApi, data),
    getOrderDateDots: (params) => window.axios.get(routes.getOrderDateDotsApi, { params }),

    // timeSlotService:(data)=>window.axios.post(routes.timeslot, data),
}